// This file includes the mapping between the route and the component that should be rendered for that route.
// You are not meant to import this file on client-side code, as it will make the bundle size bigger.

import {
    CustomerLandingPageRelayQuery,
    getCustomerLandingPageRelayQueryVars
} from "src/contentful/graphql/customer-landing-page";

import { RELAY_API_CONTENTFUL } from "@/utils/constant";
import { experiments, getExperiment } from "@/utils/experiment";

import {
    AnchorPageRelayQuery,
    getAnchorPageRelayQueryVars,
    getPricingPageRelayQueryVars,
    PricingPageRelayQuery,
    AgileOverviewOneQuery,
    getAgileOverviewQueryVars,
    AgileTutorialOneQuery,
    getAgileTutorialQueryVars,
    AgileArticleOneQuery,
    getAgileArticleQueryVars
} from "./contentful/graphql";
import { FourOhFourPage } from "./pages/404/404-page";
import { AgileArticlePage } from "./pages/agile/article/agile-article-page.tsx";
import { AgileOverviewPage } from "./pages/agile/overview/agile-overview-page.tsx";
import { AgileTutorialPage } from "./pages/agile/tutorials/agile-tutorial-page.tsx";
import { BuyCloudOrgSetupPage } from "./pages/buy/cloud/org-setup/buy-cloud-org-setup-page";
import { BuyCloudPostOrderProvisioningPage } from "./pages/buy/cloud/post-order-provisioning/buy-cloud-post-order-provisioning-page";
import { BuyCloudSiteSetupPage } from "./pages/buy/cloud/site-setup/buy-cloud-site-setup-page.tsx";
import CDNLibrary from "./pages/cdn-library/cdn-library.tsx";
import { StrategyCollectionPricingPageRelay } from "./pages/collections/strategy/pricing/strategy-collection-pricing-page-relay.tsx";
import { StrategyCollectionPricingPage } from "./pages/collections/strategy/pricing/strategy-collection-pricing-page.tsx";
import { TeamworkCollectionPricingPageRelay } from "./pages/collections/teamwork/pricing/teamwork-collection-pricing-page-relay.tsx";
import { TeamworkCollectionPricingPage } from "./pages/collections/teamwork/pricing/teamwork-collection-pricing-page.tsx";
import { CustomersLandingPage } from "./pages/customers/customers-landing-page";
import { EnterpriseContactSalesPage } from "./pages/enterprise/contact/enterprise-contact-sales-page.tsx";
import { EnterpriseContactThanksPage } from "./pages/enterprise/contact-thanks/enterprise-contact-thanks-page";
import { EnterpriseLandingPage } from "./pages/enterprise/enterprise-landing-page";
import { FastshiftDashboardPage } from "./pages/fastshift/dashboard/fastshift-dashboard-page";
import { HomePage } from "./pages/home/home-page";
import { JiraLandingPage } from "./pages/jira/jira-landing-page";
import { CheckemailPage } from "./pages/ondemand/signup/checkemail/checkemail-page";
import { ConfirmationPage } from "./pages/ondemand/signup/confirmation/confirmation-page";
import { SearchResultsPage } from "./pages/search/search.tsx";
import { SoftwareBitbucketPricingPage } from "./pages/software/bitbucket/pricing/software-bitbucket-pricing-page";
import { SoftwareBitbucketPricingPageRelay } from "./pages/software/bitbucket/pricing/software-bitbucket-pricing-page-relay";
import { SoftwareCompassPricingPage } from "./pages/software/compass/pricing/software-compass-pricing-page";
import { SoftwareCompassPricingPageRelay } from "./pages/software/compass/pricing/software-compass-pricing-page-relay";
import { ConfluenceSoftwarePageAnchorAutomation } from "./pages/software/confluence/anchors/anchor-lp-conf-automation";
import { ConfluenceSoftwarePageAnchorAutomationRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-automation-relay";
import { ConfluenceSoftwarePageVariantAnchorLpConfCollaboration } from "./pages/software/confluence/anchors/anchor-lp-conf-collaboration";
import { ConfluenceSoftwarePageVariantAnchorLpConfCollaborationRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-collaboration-relay";
import { ConfluenceSoftwarePageAnchorCompetitors } from "./pages/software/confluence/anchors/anchor-lp-conf-competitors";
import { ConfluenceSoftwarePageAnchorCompetitorsRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-competitors-relay";
import { ConfluenceSoftwarePageAnchorCustomerServiceRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-team-customerservice-relay.tsx";
import { ConfluenceSoftwarePageAnchorCustomerService } from "./pages/software/confluence/anchors/anchor-lp-conf-team-customerservice.tsx";
import { ConfluenceSoftwarePageAnchorDesignRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-team-design-relay.tsx";
import { ConfluenceSoftwarePageAnchorDesign } from "./pages/software/confluence/anchors/anchor-lp-conf-team-design.tsx";
import { ConfluenceSoftwarePageAnchorEngineering } from "./pages/software/confluence/anchors/anchor-lp-conf-team-engineering";
import { ConfluenceSoftwarePageAnchorEngineeringRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-team-engineering-relay";
import { ConfluenceSoftwarePageAnchorHrRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-team-hr-relay.tsx";
import { ConfluenceSoftwarePageAnchorHr } from "./pages/software/confluence/anchors/anchor-lp-conf-team-hr.tsx";
import { ConfluenceSoftwarePageAnchorLegalRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-team-legal-relay.tsx";
import { ConfluenceSoftwarePageAnchorLegal } from "./pages/software/confluence/anchors/anchor-lp-conf-team-legal.tsx";
import { ConfluenceSoftwarePageAnchorMarketingRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-team-marketing-relay.tsx";
import { ConfluenceSoftwarePageAnchorMarketing } from "./pages/software/confluence/anchors/anchor-lp-conf-team-marketing.tsx";
import { ConfluenceSoftwarePageAnchorOperationsRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-team-operations-relay.tsx";
import { ConfluenceSoftwarePageAnchorOperations } from "./pages/software/confluence/anchors/anchor-lp-conf-team-operations.tsx";
import { ConfluenceSoftwarePageAnchorProgramMgmtRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-team-programmgmt-relay.tsx";
import { ConfluenceSoftwarePageAnchorProgramMgmt } from "./pages/software/confluence/anchors/anchor-lp-conf-team-programmgmt.tsx";
import { ConfluenceSoftwarePageAnchorTeamwork } from "./pages/software/confluence/anchors/anchor-lp-conf-teamwork";
import { ConfluenceSoftwarePageAnchorTeamworkRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-teamwork-relay";
import { ConfluenceSoftwarePageAnchorWorkManagement } from "./pages/software/confluence/anchors/anchor-lp-conf-work-management";
import { ConfluenceSoftwarePageAnchorWorkManagementRelay } from "./pages/software/confluence/anchors/anchor-lp-conf-work-management-relay";
import { ConfluenceSoftwarePageVariantPaidLpConfFeaturesRelay } from "./pages/software/confluence/anchors/cfind-3627/paid-lp-conf-features-relay.tsx";
import { ConfluenceSoftwarePage } from "./pages/software/confluence/anchors/confluence-software-page";
import {
    isTargetedKeyword,
    getPageId as getPageIdKeywords
} from "./pages/software/confluence/anchors/keywords/keyword-util.tsx";
import { ConfluenceSoftwarePageVariantPaidLpConfFeatures } from "./pages/software/confluence/anchors/paid-lp-conf-features";
import { ConfluenceSoftwarePageVariantPaidLpConfKeywordsRelay } from "./pages/software/confluence/anchors/paid-lp-conf-keywords-relay.tsx";
import { ConfluenceSoftwarePageVariantPaidLpConfKeywords } from "./pages/software/confluence/anchors/paid-lp-conf-keywords.tsx";
import { ConfluenceSoftwarePageVariantPaidLpConfSubAnchorsRelay } from "./pages/software/confluence/anchors/paid-lp-conf-sub-anchors-relay.tsx";
import { ConfluenceSoftwarePageVariantPaidLpConfSubAnchors } from "./pages/software/confluence/anchors/paid-lp-conf-sub-anchors.tsx";
import { ConfluenceSoftwarePageVariantPaidLpConflDocumentation } from "./pages/software/confluence/anchors/paid-lp-confl-documentation";
import { ConfluenceSoftwarePageVariantPaidLpConflDocumentationRelay } from "./pages/software/confluence/anchors/paid-lp-confl-documentation-relay";
import { ConfluenceSoftwarePageVariantPaidLpConflProjectMgmtRelay } from "./pages/software/confluence/anchors/paid-lp-confl-projectmgmt-relay.tsx";
import { ConfluenceSoftwarePageVariantPaidLpConflProjectMgmt } from "./pages/software/confluence/anchors/paid-lp-confl-projectmgmt.tsx";
import { ConfluenceSoftwarePageVariantPaidLpConflTemplate } from "./pages/software/confluence/anchors/paid-lp-confl-template";
import { ConfluenceSoftwarePageVariantPaidLpConflTemplateRelay } from "./pages/software/confluence/anchors/paid-lp-confl-template-relay";
import { ConfluenceSoftwarePageVariantPaidLpXflowRedesignExperiment } from "./pages/software/confluence/anchors/paid-lp-xflow-redesign-experiment";
import {
    isTargetedSubAnchor,
    getPageId
} from "./pages/software/confluence/anchors/subAnchors/subAnchor-util.tsx";
import { ConfluenceFreePage } from "./pages/software/confluence/free/confluence-free-page.tsx";
import { ConfluencePricingPage } from "./pages/software/confluence/pricing/confluence-pricing-page";
import { ConfluencePricingPageRelay } from "./pages/software/confluence/pricing/confluence-pricing-page-relay";
import { getPricingTitleInternal as getConfluencePricingTitleInternal } from "./pages/software/confluence/pricing/feature-gates";
import { ConfluenceTemplateCategoryPage } from "./pages/software/confluence/templates/categories/confluence-template-category-page";
import { ConfluenceTemplateCategoryRelayPage } from "./pages/software/confluence/templates/categories/confluence-template-category-relay-page";
import { ConfluenceTemplateCollectionDetailsRelayPage as ConfluenceTemplateCollectionDetailsContentfulRelayPage } from "./pages/software/confluence/templates/collections/confluence-template-collection-details-contentful-relay-page";
import { ConfluenceTemplateCollectionDetailsPage } from "./pages/software/confluence/templates/collections/confluence-template-collection-details-page";
import { ConfluenceTemplateCollectionDetailsRelayPage } from "./pages/software/confluence/templates/collections/confluence-template-collection-details-relay-page";
import { ConfluenceTemplateDetailsRelayPage as ConfluenceTemplateDetailsContentfulRelayPage } from "./pages/software/confluence/templates/confluence-template-details-contentful-relay-page.tsx";
import { ConfluenceTemplateDetailsPage } from "./pages/software/confluence/templates/confluence-template-details-page";
import { ConfluenceTemplateDetailsRelayPage } from "./pages/software/confluence/templates/confluence-template-details-relay-page";
import { ConfluenceTemplatesPage } from "./pages/software/confluence/templates/confluence-templates-page";
import { ConfluenceTemplatesRelayPage } from "./pages/software/confluence/templates/confluence-templates-relay-page";
import { ConfluenceTemplateSearchPage } from "./pages/software/confluence/templates/search/confluence-template-search-page";
import { ConfluenceTemplateSearchRelayPage } from "./pages/software/confluence/templates/search/confluence-template-search-relay-page";
import { SoftwareGuardPricingPageRelay } from "./pages/software/guard/pricing/software-guard-pricing-page-relay";
import { SoftwareGuardPricingPage } from "./pages/software/guard/pricing/software-guard-pricing-page.tsx";
import { JiraSoftwarePageAnchorLpJswDesignRelay } from "./pages/software/jira/anchors/anchor-lp-jsw-team-design-relay.tsx";
import { JiraSoftwarePageAnchorLpJswDesign } from "./pages/software/jira/anchors/anchor-lp-jsw-team-design.tsx";
import { JiraSoftwarePageAnchorLpJswEngineeringRelay } from "./pages/software/jira/anchors/anchor-lp-jsw-team-engineering-relay.tsx";
import { JiraSoftwarePageAnchorLpJswEngineering } from "./pages/software/jira/anchors/anchor-lp-jsw-team-engineering.tsx";
import { JiraSoftwarePageAnchorLpJswHrRelay } from "./pages/software/jira/anchors/anchor-lp-jsw-team-hr-relay.tsx";
import { JiraSoftwarePageAnchorLpJswHr } from "./pages/software/jira/anchors/anchor-lp-jsw-team-hr.tsx";
import { JiraSoftwarePageAnchorLpJswLegalRelay } from "./pages/software/jira/anchors/anchor-lp-jsw-team-legal-relay.tsx";
import { JiraSoftwarePageAnchorLpJswLegal } from "./pages/software/jira/anchors/anchor-lp-jsw-team-legal.tsx";
import { JiraSoftwarePageAnchorLpJswMarketingRelay } from "./pages/software/jira/anchors/anchor-lp-jsw-team-marketing-relay.tsx";
import { JiraSoftwarePageAnchorLpJswMarketing } from "./pages/software/jira/anchors/anchor-lp-jsw-team-marketing.tsx";
import { JiraSoftwarePageAnchorLpJswOperationsRelay } from "./pages/software/jira/anchors/anchor-lp-jsw-team-operations-relay.tsx";
import { JiraSoftwarePageAnchorLpJswOperations } from "./pages/software/jira/anchors/anchor-lp-jsw-team-operations.tsx";
import { JiraSoftwarePageAnchorLpJswProgramMgmtRelay } from "./pages/software/jira/anchors/anchor-lp-jsw-team-programmgmt-relay.tsx";
import { JiraSoftwarePageAnchorLpJswProgramMgmt } from "./pages/software/jira/anchors/anchor-lp-jsw-team-programmgmt.tsx";
import { JiraSoftwarePageAnchorLpJswSalesRelay } from "./pages/software/jira/anchors/anchor-lp-jsw-team-sales-relay.tsx";
import { JiraSoftwarePageAnchorLpJswSales } from "./pages/software/jira/anchors/anchor-lp-jsw-team-sales.tsx";
import { JiraSoftwarePage } from "./pages/software/jira/anchors/jira-software-page";
import { JiraSoftwarePagePaidLpJswAgileRelay } from "./pages/software/jira/anchors/paid-lp-jsw-agile-relay.tsx";
import { JiraSoftwarePagePaidLpJswAgile } from "./pages/software/jira/anchors/paid-lp-jsw-agile.tsx";
import { JiraSoftwarePagePaidLpJswAutomationRelay } from "./pages/software/jira/anchors/paid-lp-jsw-automation-relay.tsx";
import { JiraSoftwarePagePaidLpJswAutomation } from "./pages/software/jira/anchors/paid-lp-jsw-automation.tsx";
import { JiraSoftwarePagePaidLpJswCompetitorsRelay } from "./pages/software/jira/anchors/paid-lp-jsw-competitors-relay.tsx";
import { JiraSoftwarePagePaidLpJswCompetitors } from "./pages/software/jira/anchors/paid-lp-jsw-competitors.tsx";
import { JiraSoftwarePagePaidLpJswFeatures } from "./pages/software/jira/anchors/paid-lp-jsw-features";
import { JiraSoftwarePagePaidLpJswPm } from "./pages/software/jira/anchors/paid-lp-jsw-pm";
import { JiraSoftwarePagePaidLpJswPmRelay } from "./pages/software/jira/anchors/paid-lp-jsw-pm-relay";
import { JiraSoftwarePagePaidLpJswProjCollabRelay } from "./pages/software/jira/anchors/paid-lp-jsw-project-collaboration-relay.tsx";
import { JiraSoftwarePagePaidLpJswProjCollab } from "./pages/software/jira/anchors/paid-lp-jsw-project-collaboration.tsx";
import { JiraSoftwarePagePaidLpJswRoadmaps } from "./pages/software/jira/anchors/paid-lp-jsw-roadmaps";
import { JiraSoftwarePagePaidLpJswRoadmapsRelay } from "./pages/software/jira/anchors/paid-lp-jsw-roadmaps-relay";
import { JiraSoftwarePagePaidLpJswTeamworkRelay } from "./pages/software/jira/anchors/paid-lp-jsw-teamwork-relay.tsx";
import { JiraSoftwarePagePaidLpJswTeamwork } from "./pages/software/jira/anchors/paid-lp-jsw-teamwork.tsx";
import { JiraSoftwarePagePaidLpJswTemplate } from "./pages/software/jira/anchors/paid-lp-jsw-template";
import { JiraSoftwarePagePaidLpJswTemplateRelay } from "./pages/software/jira/anchors/paid-lp-jsw-template-relay";
import { JiraSoftwarePagePaidLpJswTracker } from "./pages/software/jira/anchors/paid-lp-jsw-tracker";
import { JiraSoftwarePagePaidLpJswTrackerRelay } from "./pages/software/jira/anchors/paid-lp-jsw-tracker-relay";
import { JiraSoftwareFeaturesPage } from "./pages/software/jira/features/jira-software-features-page";
import { JiraSoftwareFreePage } from "./pages/software/jira/free/jira-software-free-page";
import { getPricingTitleInternal as getJiraPricingTitleInternal } from "./pages/software/jira/pricing/feature-gates";
import { JiraSoftwarePricingPage } from "./pages/software/jira/pricing/jira-software-pricing-page";
import { JiraSoftwarePricingPageRelay } from "./pages/software/jira/pricing/jira-software-pricing-page-relay";
import { JiraProductDiscoveryPage } from "./pages/software/jira/product-discovery/jira-product-discovery-page";
import { getPricingTitleInternal as getJiraProductDiscoveryPricingTitleInternal } from "./pages/software/jira/product-discovery/pricing/feature-gates";
import { JiraProductDiscoveryPricingPageRelay } from "./pages/software/jira/product-discovery/pricing/jira-product-discovery-pricing-page-relay";
import { JiraProductDiscoveryPricingPage } from "./pages/software/jira/product-discovery/pricing/jira-product-discovery-pricing-page.tsx";
import { JiraServiceManagementSoftwarePageAnchorLpJsmAsset } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-asset";
import { JiraServiceManagementSoftwarePageAnchorLpJsmAssetRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-asset-relay";
import { JiraServiceManagementSoftwarePageAnchorAutomation } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-automation";
import { JiraServiceManagementSoftwarePageAnchorAutomationRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-automation-relay";
import { JiraServiceManagementSoftwarePageAnchorCompetitors } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-competitors";
import { JiraServiceManagementSoftwarePageAnchorCompetitorsRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-competitors-relay";
import { JiraServiceManagementSoftwarePageAnchorCsm } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-csm";
import { JiraServiceManagementSoftwarePageAnchorCsmRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-csm-relay";
import { JiraServiceManagementSoftwarePageAnchorLpJsmDevops } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-devops";
import { JiraServiceManagementSoftwarePageAnchorLpJsmDevopsRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-devops-relay";
import { JiraServiceManagementSoftwarePageAnchorEsm } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-esm";
import { JiraServiceManagementSoftwarePageAnchorEsmRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-esm-relay";
import { JiraServiceManagementSoftwarePageAnchorCustomerServiceRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-customerservice-relay.tsx";
import { JiraServiceManagementSoftwarePageAnchorCustomerService } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-customerservice.tsx";
import { JiraServiceManagementSoftwarePageAnchorDesignRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-design-relay.tsx";
import { JiraServiceManagementSoftwarePageAnchorDesign } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-design.tsx";
import { JiraServiceManagementSoftwarePageAnchorEngineeringRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-engineering-relay.tsx";
import { JiraServiceManagementSoftwarePageAnchorEngineering } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-engineering.tsx";
import { JiraServiceManagementSoftwarePageAnchorHrRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-hr-relay.tsx";
import { JiraServiceManagementSoftwarePageAnchorHr } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-hr.tsx";
import { JiraServiceManagementSoftwarePageAnchorLegalRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-legal-relay.tsx";
import { JiraServiceManagementSoftwarePageAnchorLegal } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-legal.tsx";
import { JiraServiceManagementSoftwarePageAnchorMarketingRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-marketing-relay.tsx";
import { JiraServiceManagementSoftwarePageAnchorMarketing } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-marketing.tsx";
import { JiraServiceManagementSoftwarePageAnchorOperationsRelay } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-operations-relay.tsx";
import { JiraServiceManagementSoftwarePageAnchorOperations } from "./pages/software/jira/service-management/anchors/anchor-lp-jsm-team-operations.tsx";
import { JiraServiceManagementSoftwarePage } from "./pages/software/jira/service-management/anchors/jira-service-management-software-page";
import { JiraServiceManagementSoftwarePagePaidLpJsmFeatures } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-features";
import { JiraServiceManagementSoftwarePagePaidLpJsmFeaturesCerebro } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-features-cerebro";
import { JiraServiceManagementSoftwarePagePaidLpJsmFeaturesCerebroRelay } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-features-cerebro-relay";
import { JiraServiceManagementSoftwarePagePaidLpJsmFeaturesRelay } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-features-relay";
import { JiraServiceManagementSoftwarePagePaidLpJsmIncidentchangemgmt } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-incidentchangemgmt";
import { JiraServiceManagementSoftwarePagePaidLpJsmIncidentchangemgmtRelay } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-incidentchangemgmt-relay";
import { JiraServiceManagementSoftwarePagePaidLpJsmItsm } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-itsm";
import { JiraServiceManagementSoftwarePagePaidLpJsmItsmRelay } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-itsm-relay";
import { JiraServiceManagementSoftwarePagePaidLpJsmServiceDesk } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-service-desk";
import { JiraServiceManagementSoftwarePagePaidLpJsmServiceDeskRelay } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-service-desk-relay";
import { JiraServiceManagementSoftwarePagePaidLpJsmTicketing } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-ticketing";
import { JiraServiceManagementSoftwarePagePaidLpJsmTicketingRelay } from "./pages/software/jira/service-management/anchors/paid-lp-jsm-ticketing-relay";
import { getPricingTitleInternal as getJiraServiceManagementPricingTitleInternal } from "./pages/software/jira/service-management/pricing/feature-gates";
import { JiraServiceManagementPricingPage } from "./pages/software/jira/service-management/pricing/jira-service-management-pricing-page";
import { JiraServiceManagementPricingPageRelay } from "./pages/software/jira/service-management/pricing/jira-service-management-pricing-page-relay";
import { JiraTemplateCategoryPage } from "./pages/software/jira/templates/service-management/jira-template-category-page";
import { LoomPricingPageRelay } from "./pages/software/loom/pricing/loom-pricing-page-relay";
import { LoomPricingPage } from "./pages/software/loom/pricing/loom-pricing-page.tsx";
import { SoftwareRovoPricingPage } from "./pages/software/rovo/pricing/software-rovo-pricing-page";
import { SoftwareRovoPricingPageRelay } from "./pages/software/rovo/pricing/software-rovo-pricing-page-relay";
import { SoftwareRovoStartPage } from "./pages/software/rovo/start/software-rovo-start-page";
import { NonProfitPricingPage } from "./pages/teams/nonprofit/pricing/non-profit-pricing-page";
import { NonProfitPricingPageRelay } from "./pages/teams/nonprofit/pricing/non-profit-pricing-page-relay";
import { TestUniformPage } from "./pages/test-uniform/test-uniform-page";
import { SignupPage } from "./pages/try/cloud/signup/signup-page";
import { TryPage } from "./pages/try/try-page";
import { UniformPreviewPage } from "./pages/uniform-preview/uniform-preview-page";
import {
    ConfluenceTemplateCollectionDetailsRelayPageQuery,
    getConfluenceTemplateCollectionDetailsRelayPageQueryVars
} from "./templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-template-collection-details-relay-page.template.tsx";
import {
    ConfluenceTemplateDetailsRelayPageQuery,
    getConfluenceTemplateDetailsRelayPageQueryVars
} from "./templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-template-details-relay-page.template.tsx";
import {
    ConfluenceTemplatesUnifiedRelayPageQuery,
    getConfluenceTemplatesUnifiedRelayPageQueryVars
} from "./templates/software/confluence/templates/confluence-templates-page/src/relay/confluence-templates-unified-relay-page.template";
import {
    ConfluenceTemplateCollectionDetailsRelayPageQuery as ConfluenceTemplateCollectionDetailsContentfulRelayPageQuery,
    getConfluenceTemplateCollectionDetailsRelayPageQueryVars as getConfluenceTemplateCollectionDetailsContentfulRelayPageQueryVars
} from "./templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-template-collection-details-contentful-relay-page.template.tsx";
import { ConfluenceTemplateDetailsRelayPageQuery as ConfluenceTemplateDetailsContentfulRelayPageQuery } from "./templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-template-details-contentful-relay-page.template.tsx";
import { getConfluenceTemplateDetailsRelayPageQueryVars as getConfluenceTemplateDetailsContentfulRelayPageQueryVars } from "./templates/software/confluence/templates/confluence-templates-page/src/relay/contentful-relay/confluence-template-details-contentful-relay-page.template.tsx";
import { checkFeatureFlagGate } from "./utils/feature-flags/check-feature-flag.ts";
import { featureFlags } from "./utils/feature-flags/feature-flag-manifest.ts";
import { getConfTemplatesRelayExperimentWithExposure } from "./utils/get-conf-templates-relay-experiment-with-exposure";
import { parseRoute } from "./wac-routes";
// Ensure the correct path to the module

// eslint-disable-next-line complexity
export const getRoute = (
    location: Location,
    userLocale?: string,
    userLoggedIn?: boolean,
    subAnchor?: string
) => {
    const route = parseRoute(location);
    switch (route.path) {
        case "fastshift/dashboard":
            if (
                checkFeatureFlagGate(featureFlags.sxpEnableFastshiftPortal) &&
                userLoggedIn
            ) {
                switch (route.variant) {
                    default:
                        return {
                            Component: FastshiftDashboardPage,
                            entryName: "fastshift-dashboard-page"
                        };
                }
            } else {
                return { Component: FourOhFourPage, entryName: "404" };
            }
        case "uniform-preview":
            if (process.env["NODE_ENV"] === "production") {
                return { Component: FourOhFourPage, entryName: "404" };
            }
            switch (route.variant) {
                default:
                    return {
                        Component: UniformPreviewPage,
                        entryName: "uniform-preview-page",
                        isUniformRoute: true
                    };
            }

        case "software/rovo/pricing":
            switch (route.variant) {
                default:
                    if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                        return {
                            Component: SoftwareRovoPricingPageRelay,
                            entryName: "software-rovo-pricing-page-relay",
                            query: PricingPageRelayQuery,
                            queryVars: getPricingPageRelayQueryVars(
                                "rovo",
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: SoftwareRovoPricingPage,
                        entryName: "software-rovo-pricing-page"
                    };
            }
        case "software/jira/product-discovery/pricing":
            switch (route.variant) {
                default:
                    if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                        const jiraProductDiscoveryPricingTitle =
                            getJiraProductDiscoveryPricingTitleInternal();
                        return {
                            Component: JiraProductDiscoveryPricingPageRelay,
                            entryName:
                                "jira-product-discovery-pricing-page-relay",
                            query: PricingPageRelayQuery,
                            queryVars: getPricingPageRelayQueryVars(
                                "jira-product-discovery",
                                location,
                                jiraProductDiscoveryPricingTitle
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraProductDiscoveryPricingPage,
                        entryName: "jira-product-discovery-pricing-page"
                    };
            }
        case "software/guard/pricing":
            switch (route.variant) {
                default:
                    if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                        return {
                            Component: SoftwareGuardPricingPageRelay,
                            entryName: "software-guard-pricing-page-relay",
                            query: PricingPageRelayQuery,
                            queryVars: getPricingPageRelayQueryVars(
                                "atlassian-access",
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: SoftwareGuardPricingPage,
                        entryName: "software-guard-pricing-page"
                    };
            }
        case "software/compass/pricing":
            switch (route.variant) {
                default:
                    if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                        return {
                            Component: SoftwareCompassPricingPageRelay,
                            entryName: "software-compass-pricing-page-relay",
                            query: PricingPageRelayQuery,
                            queryVars: getPricingPageRelayQueryVars(
                                "compass",
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: SoftwareCompassPricingPage,
                        entryName: "software-compass-pricing-page"
                    };
            }
        case "software/loom/pricing":
            switch (route.variant) {
                default:
                    if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                        return {
                            Component: LoomPricingPageRelay,
                            entryName: "loom-pricing-page-relay",
                            query: PricingPageRelayQuery,
                            queryVars: getPricingPageRelayQueryVars(
                                "loom",
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: LoomPricingPage,
                        entryName: "loom-pricing-page"
                    };
            }
        case "collections/teamwork/pricing":
            switch (route.variant) {
                default:
                    if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                        return {
                            Component: TeamworkCollectionPricingPageRelay,
                            entryName: "teamwork-collection-pricing-page-relay",
                            query: PricingPageRelayQuery,
                            queryVars: getPricingPageRelayQueryVars(
                                "teamwork",
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: TeamworkCollectionPricingPage,
                        entryName: "teamwork-collection-pricing-page"
                    };
            }
        case "collections/strategy/pricing":
            switch (route.variant) {
                default:
                    if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                        return {
                            Component: StrategyCollectionPricingPageRelay,
                            entryName: "strategy-collection-pricing-page-relay",
                            query: PricingPageRelayQuery,
                            queryVars: getPricingPageRelayQueryVars(
                                "strategy",
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: StrategyCollectionPricingPage,
                        entryName: "strategy-collection-pricing-page"
                    };
            }
        case "buy/cloud/org-setup":
            switch (route.variant) {
                default:
                    return {
                        Component: BuyCloudOrgSetupPage,
                        entryName: "buy-cloud-org-setup-page"
                    };
            }
        case "buy/cloud/site-setup":
            switch (route.variant) {
                default:
                    return {
                        Component: BuyCloudSiteSetupPage,
                        entryName: "buy-cloud-site-setup-page"
                    };
            }
        case "software/bitbucket/pricing":
            switch (route.variant) {
                default:
                    if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                        return {
                            Component: SoftwareBitbucketPricingPageRelay,
                            entryName: "software-bitbucket-pricing-page-relay",
                            query: PricingPageRelayQuery,
                            queryVars: getPricingPageRelayQueryVars(
                                "bitbucket",
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: SoftwareBitbucketPricingPage,
                        entryName: "software-bitbucket-pricing-page"
                    };
            }
        case "buy/cloud/post-order-provisioning":
            switch (route.variant) {
                default:
                    return {
                        Component: BuyCloudPostOrderProvisioningPage,
                        entryName: "buy-cloud-post-order-provisioning-page"
                    };
            }
        case "software/rovo/start":
            switch (route.variant) {
                default:
                    return {
                        Component: SoftwareRovoStartPage,
                        entryName: "software-rovo-start-page"
                    };
            }
        case "agile/advantage":
        case "agile/agile-conversations":
        case "agile/agile-at-scale":
        case "agile/agile-marketing":
        case "agile/design":
        case "agile/kanban":
        case "agile/product-management":
        case "agile/project-management":
        case "agile/scrum":
        case "agile/software-development":
        case "agile/teams":
        case "agile/tutorials":
            return {
                Component: AgileOverviewPage,
                entryName: "agile-overview",
                query: AgileOverviewOneQuery,
                queryVars: getAgileOverviewQueryVars(location),
                isRelayEnabled: true,
                relayApi: RELAY_API_CONTENTFUL
            };
        case `agile/advantage${getRouteExtension(
            route.path,
            "agile/advantage"
        )}`:
        case `agile/agile-conversations${getRouteExtension(
            route.path,
            "agile/agile-conversations"
        )}`:
        case `agile/agile-at-scale${getRouteExtension(
            route.path,
            "agile/agile-at-scale"
        )}`:
        case `agile/agile-marketing${getRouteExtension(
            route.path,
            "agile/agile-marketing"
        )}`:
        case `agile/design${getRouteExtension(route.path, "agile/design")}`:
        case `agile/kanban${getRouteExtension(route.path, "agile/kanban")}`:
        case `agile/product-management${getRouteExtension(
            route.path,
            "agile/product-management"
        )}`:
        case `agile/project-management${getRouteExtension(
            route.path,
            "agile/project-management"
        )}`:
        case `agile/scrum${getRouteExtension(route.path, "agile/scrum")}`:
        case `agile/software-development${getRouteExtension(
            route.path,
            "agile/software-development"
        )}`:
        case `agile/teams${getRouteExtension(route.path, "agile/teams")}`:
        case `agile/devops`:
            return {
                Component: AgileArticlePage,
                entryName: "agile-article",
                query: AgileArticleOneQuery,
                queryVars: getAgileArticleQueryVars(location),
                isRelayEnabled: true,
                relayApi: RELAY_API_CONTENTFUL
            };

        case `agile/tutorials${getRouteExtension(
            route.path,
            "agile/tutorials"
        )}`:
            return {
                Component: AgileTutorialPage,
                entryName: "agile-tutorial",
                query: AgileTutorialOneQuery,
                queryVars: getAgileTutorialQueryVars(location),
                isRelayEnabled: true,
                relayApi: RELAY_API_CONTENTFUL
            };
        case "customers":
            return {
                Component: CustomersLandingPage,
                entryName: "customers-landing-page",
                query: CustomerLandingPageRelayQuery,
                queryVars: getCustomerLandingPageRelayQueryVars(location),
                isRelayEnabled: true,
                relayApi: RELAY_API_CONTENTFUL
            };
        case `customers${getRouteExtension(route.path, "customers")}`:
            if (
                // these should only be of the form `customers/<slug>`.
                // There should never be more than 2 parts
                getRouteExtension(route.path, "customers").split("/").length > 2
            ) {
                return { Component: FourOhFourPage, entryName: "404" };
            }
            return {
                Component: TestUniformPage,
                entryName: "test-uniform-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };
        case "jira":
            return {
                Component: JiraLandingPage,
                entryName: "jira-landing-page"
            };

        case "software/jira":
            const cpapiDeprecationJiraExperiment = route.variant
                ? getExperiment(experiments.cpapiDeprecationJiraExperiment)
                : {
                      type: "enrolled",
                      value: false
                  };
            const isEnrolledCpapiDeprecationJira =
                cpapiDeprecationJiraExperiment.type == "enrolled" &&
                cpapiDeprecationJiraExperiment.value;

            switch (route.variant) {
                case "paid-lp-jsw-features":
                    return {
                        Component: JiraSoftwarePagePaidLpJswFeatures,
                        entryName: "jira-software-page-paid-lp-jsw-features"
                    };
                case "paid-lp-jsw-roadmaps":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePagePaidLpJswRoadmapsRelay,
                            entryName:
                                "jira-software-page-paid-lp-jsw-roadmaps-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePagePaidLpJswRoadmaps,
                        entryName: "jira-software-page-paid-lp-jsw-roadmaps"
                    };
                case "paid-lp-jsw-template":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePagePaidLpJswTemplateRelay,
                            entryName:
                                "jira-software-page-paid-lp-jsw-template-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePagePaidLpJswTemplate,
                        entryName: "jira-software-page-paid-lp-jsw-template"
                    };
                case "paid-lp-jsw-tracker":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePagePaidLpJswTrackerRelay,
                            entryName:
                                "jira-software-page-paid-lp-jsw-tracker-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePagePaidLpJswTracker,
                        entryName: "jira-software-page-paid-lp-jsw-tracker"
                    };
                case "paid-lp-jsw-pm":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePagePaidLpJswPmRelay,
                            entryName:
                                "jira-software-page-paid-lp-jsw-pm-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePagePaidLpJswPm,
                        entryName: "jira-software-page-paid-lp-jsw-pm"
                    };
                case "paid-lp-jsw-project_collaboration":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePagePaidLpJswProjCollabRelay,
                            entryName:
                                "jira-software-page-paid-lp-jsw-project_collaboration-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePagePaidLpJswProjCollab,
                        entryName:
                            "jira-software-page-paid-lp-jsw-project_collaboration"
                    };
                case "paid-lp-jsw-automation":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePagePaidLpJswAutomationRelay,
                            entryName:
                                "jira-software-page-paid-lp-jsw-automation-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePagePaidLpJswAutomation,
                        entryName: "jira-software-page-paid-lp-jsw-automation"
                    };
                case "paid-lp-jsw-teamwork":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePagePaidLpJswTeamworkRelay,
                            entryName:
                                "jira-software-page-paid-lp-jsw-teamwork-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePagePaidLpJswTeamwork,
                        entryName: "jira-software-page-paid-lp-jsw-teamwork"
                    };
                case "paid-lp-jsw-agile":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePagePaidLpJswAgileRelay,
                            entryName:
                                "jira-software-page-paid-lp-jsw-agile-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePagePaidLpJswAgile,
                        entryName: "jira-software-page-paid-lp-jsw-agile"
                    };
                case "paid-lp-jsw-competitors":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component:
                                JiraSoftwarePagePaidLpJswCompetitorsRelay,
                            entryName:
                                "jira-software-page-paid-lp-jsw-competitors-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePagePaidLpJswCompetitors,
                        entryName: "jira-software-page-paid-lp-jsw-competitors"
                    };
                case "anchor-lp-jsw-team-engineering":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component:
                                JiraSoftwarePageAnchorLpJswEngineeringRelay,
                            entryName:
                                "jira-software-page-anchor-lp-jsw-team-engineering-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePageAnchorLpJswEngineering,
                        entryName:
                            "jira-software-page-anchor-lp-jsw-team-engineering"
                    };
                case "anchor-lp-jsw-team-marketing":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component:
                                JiraSoftwarePageAnchorLpJswMarketingRelay,
                            entryName:
                                "jira-software-page-anchor-lp-jsw-team-marketing-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePageAnchorLpJswMarketing,
                        entryName:
                            "jira-software-page-anchor-lp-jsw-team-marketing"
                    };
                case "anchor-lp-jsw-team-hr":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePageAnchorLpJswHrRelay,
                            entryName:
                                "jira-software-page-anchor-lp-jsw-team-hr-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePageAnchorLpJswHr,
                        entryName: "jira-software-page-anchor-lp-jsw-team-hr"
                    };
                case "anchor-lp-jsw-team-legal":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePageAnchorLpJswLegalRelay,
                            entryName:
                                "jira-software-page-anchor-lp-jsw-team-legal-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePageAnchorLpJswLegal,
                        entryName: "jira-software-page-anchor-lp-jsw-team-legal"
                    };
                case "anchor-lp-jsw-team-operations":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component:
                                JiraSoftwarePageAnchorLpJswOperationsRelay,
                            entryName:
                                "jira-software-page-anchor-lp-jsw-team-operations-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePageAnchorLpJswOperations,
                        entryName:
                            "jira-software-page-anchor-lp-jsw-team-operations"
                    };
                case "anchor-lp-jsw-team-design":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePageAnchorLpJswDesignRelay,
                            entryName:
                                "jira-software-page-anchor-lp-jsw-team-design-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePageAnchorLpJswDesign,
                        entryName:
                            "jira-software-page-anchor-lp-jsw-team-design"
                    };
                case "anchor-lp-jsw-team-programmgmt":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component:
                                JiraSoftwarePageAnchorLpJswProgramMgmtRelay,
                            entryName:
                                "jira-software-page-anchor-lp-jsw-team-programmgmt-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePageAnchorLpJswProgramMgmt,
                        entryName:
                            "jira-software-page-anchor-lp-jsw-team-programmgmt"
                    };
                case "anchor-lp-jsw-team-sales":
                    if (isEnrolledCpapiDeprecationJira) {
                        return {
                            Component: JiraSoftwarePageAnchorLpJswSalesRelay,
                            entryName:
                                "jira-software-page-anchor-lp-jsw-team-sales-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraSoftwarePageAnchorLpJswSales,
                        entryName: "jira-software-page-anchor-lp-jsw-team-sales"
                    };
                default:
                    return {
                        Component: JiraSoftwarePage,
                        entryName: "jira-software-page"
                    };
            }
        case "software/jira/product-discovery":
            return {
                Component: JiraProductDiscoveryPage,
                entryName: "jira-product-discovery-page"
            };
        case "software/jira/features":
            return {
                Component: JiraSoftwareFeaturesPage,
                entryName: "jira-software-features-page"
            };

        case "software/jira/free":
            return {
                Component: JiraSoftwareFreePage,
                entryName: "jira-software-free-page"
            };

        case "software/jira/pricing":
            const cpapiDeprecationPricingJiraExperiment = getExperiment(
                experiments.cpapiDeprecationPricingJiraExperiment
            );

            const isEnrolledCpapiDeprecationPricingJira =
                cpapiDeprecationPricingJiraExperiment.type == "enrolled" &&
                cpapiDeprecationPricingJiraExperiment.value;

            const jiraPricingTitleInternal = getJiraPricingTitleInternal();

            if (isEnrolledCpapiDeprecationPricingJira) {
                return {
                    Component: JiraSoftwarePricingPageRelay,
                    entryName: "jira-software-pricing-page-relay",
                    query: PricingPageRelayQuery,
                    queryVars: getPricingPageRelayQueryVars(
                        "jira-software",
                        location,
                        jiraPricingTitleInternal
                    ),
                    isRelayEnabled: true,
                    relayApi: RELAY_API_CONTENTFUL
                };
            }
            return {
                Component: JiraSoftwarePricingPage,
                entryName: "jira-software-pricing-page"
            };

        case "software/jira/service-management":
            const cpapiDeprecationJsmExperiment = route.variant
                ? getExperiment(experiments.cpapiDeprecationJsmExperiment)
                : {
                      type: "enrolled",
                      value: false
                  };
            const isEnrolledCpapiDeprecationJsm =
                cpapiDeprecationJsmExperiment.type == "enrolled" &&
                cpapiDeprecationJsmExperiment.value;

            switch (route.variant) {
                case "anchor-lp-jsm-automation":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorAutomationRelay,
                            entryName:
                                "jira-service-management-anchor-lp-jsm-automation-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePageAnchorAutomation,
                        entryName:
                            "jira-service-management-anchor-lp-jsm-automation"
                    };
                case "anchor-lp-jsm-competitors":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorCompetitorsRelay,
                            entryName:
                                "jira-service-management-anchor-lp-jsm-competitors-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePageAnchorCompetitors,
                        entryName:
                            "jira-service-management-anchor-lp-jsm-competitors"
                    };
                case "anchor-lp-jsm-esm":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorEsmRelay,
                            entryName:
                                "jira-service-management-anchor-lp-jsm-esm-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraServiceManagementSoftwarePageAnchorEsm,
                        entryName: "jira-service-management-anchor-lp-jsm-esm"
                    };
                case "anchor-lp-jsm-csm":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorCsmRelay,
                            entryName:
                                "jira-service-management-anchor-lp-jsm-csm-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraServiceManagementSoftwarePageAnchorCsm,
                        entryName: "jira-service-management-anchor-lp-jsm-csm"
                    };
                case "anchor-lp-jsm-team-marketing":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorMarketingRelay,
                            entryName:
                                "jira-service-management-anchor-lp-jsm-team-marketing-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePageAnchorMarketing,
                        entryName:
                            "jira-service-management-anchor-lp-jsm-team-marketing"
                    };
                case "anchor-lp-jsm-team-engineering":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorEngineeringRelay,
                            entryName:
                                "jira-service-management-anchor-lp-jsm-team-engineering-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePageAnchorEngineering,
                        entryName:
                            "jira-service-management-anchor-lp-jsm-team-engineering"
                    };
                case "anchor-lp-jsm-team-hr":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorHrRelay,
                            entryName:
                                "jira-service-management-anchor-lp-jsm-team-hr-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraServiceManagementSoftwarePageAnchorHr,
                        entryName:
                            "jira-service-management-anchor-lp-jsm-team-hr"
                    };
                case "anchor-lp-jsm-team-legal":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorLegalRelay,
                            entryName:
                                "jira-service-management-anchor-lp-jsm-team-legal-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: JiraServiceManagementSoftwarePageAnchorLegal,
                        entryName:
                            "jira-service-management-anchor-lp-jsm-team-legal"
                    };
                case "anchor-lp-jsm-team-operations":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorOperationsRelay,
                            entryName:
                                "jira-service-management-anchor-lp-jsm-team-operations-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePageAnchorOperations,
                        entryName:
                            "jira-service-management-anchor-lp-jsm-team-operations"
                    };
                case "paid-lp-jsm-features":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePagePaidLpJsmFeaturesRelay,
                            entryName:
                                "jira-service-management-software-page-paid-lp-jsm-features-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePagePaidLpJsmFeatures,
                        entryName:
                            "jira-service-management-software-page-paid-lp-jsm-features"
                    };
                case "paid-lp-jsm-features-cerebro":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePagePaidLpJsmFeaturesCerebroRelay,
                            entryName:
                                "jira-service-management-software-page-paid-lp-jsm-features-cerebro-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePagePaidLpJsmFeaturesCerebro,
                        entryName:
                            "jira-service-management-software-page-paid-lp-jsm-features-cerebro"
                    };
                case "paid-lp-jsm-incidentchangemgmt":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePagePaidLpJsmIncidentchangemgmtRelay,
                            entryName:
                                "jira-service-management-software-page-paid-lp-jsm-incidentchangemgmt-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePagePaidLpJsmIncidentchangemgmt,
                        entryName:
                            "jira-service-management-software-page-paid-lp-jsm-incidentchangemgmt"
                    };
                case "paid-lp-jsm-ticketing":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePagePaidLpJsmTicketingRelay,
                            entryName:
                                "jira-service-management-software-page-paid-lp-jsm-ticketing-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePagePaidLpJsmTicketing,
                        entryName:
                            "jira-service-management-software-page-paid-lp-jsm-ticketing"
                    };
                case "paid-lp-jsm-service-desk":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePagePaidLpJsmServiceDeskRelay,
                            entryName:
                                "jira-service-management-software-page-paid-lp-jsm-service-desk-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePagePaidLpJsmServiceDesk,
                        entryName:
                            "jira-service-management-software-page-paid-lp-jsm-service-desk"
                    };
                case "paid-lp-jsm-itsm":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePagePaidLpJsmItsmRelay,
                            entryName:
                                "jira-service-management-software-page-paid-lp-jsm-itsm-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePagePaidLpJsmItsm,
                        entryName:
                            "jira-service-management-software-page-paid-lp-jsm-itsm"
                    };
                case "anchor-lp-jsm-asset":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorLpJsmAssetRelay,
                            entryName:
                                "jira-service-management-software-page-anchor-lp-jsm-asset-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePageAnchorLpJsmAsset,
                        entryName:
                            "jira-service-management-software-page-anchor-lp-jsm-asset"
                    };
                case "anchor-lp-jsm-devops":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorLpJsmDevopsRelay,
                            entryName:
                                "jira-service-management-software-page-anchor-lp-jsm-devops-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePageAnchorLpJsmDevops,
                        entryName:
                            "jira-service-management-software-page-anchor-lp-jsm-devops"
                    };
                case "anchor-lp-jsm-team-customerservice":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorCustomerServiceRelay,
                            entryName:
                                "jira-service-management-software-page-anchor-lp-jsm-team-customerservice-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePageAnchorCustomerService,
                        entryName:
                            "jira-service-management-software-page-anchor-lp-jsm-team-customerservice"
                    };
                case "anchor-lp-jsm-team-design":
                    if (isEnrolledCpapiDeprecationJsm) {
                        return {
                            Component:
                                JiraServiceManagementSoftwarePageAnchorDesignRelay,
                            entryName:
                                "jira-service-management-software-page-anchor-lp-jsm-team-design-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            JiraServiceManagementSoftwarePageAnchorDesign,
                        entryName:
                            "jira-service-management-software-page-anchor-lp-jsm-team-design"
                    };
                default:
                    return {
                        Component: JiraServiceManagementSoftwarePage,
                        entryName: "jira-service-management-software-page"
                    };
            }
        case "software/confluence":
            const cpapiDeprecationConfExperiment = route.variant
                ? getExperiment(experiments.cpapiDeprecationConfExperiment)
                : {
                      type: "enrolled",
                      value: false
                  };
            const isEnrolledCpapiDeprecationConf =
                cpapiDeprecationConfExperiment.type == "enrolled" &&
                cpapiDeprecationConfExperiment.value;

            const excludedCountyCodesFromExperiment = ["IN", "ID", "GB"];
            const excludedCountry =
                userLocale != null &&
                excludedCountyCodesFromExperiment.includes(userLocale);

            const brandAnchorVisualCleanup = getExperiment(
                experiments.cfind3627BrandAnchorVisualCleanup
            );

            if (
                route.variant &&
                isTargetedSubAnchor(subAnchor) &&
                !excludedCountry
            ) {
                const subAnchorExperiment = getExperiment(
                    experiments.cfind3254LandingPageSubAnchor
                );
                // if treatment return the sub anchor experiment, else control gets whatever normal route behavior is
                if (
                    subAnchorExperiment.type == "enrolled" &&
                    subAnchorExperiment.value
                ) {
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageVariantPaidLpConfSubAnchorsRelay,
                            entryName:
                                "confluence-software-page-variant-paid-lp-conf-subAnchors-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                getPageId(subAnchor),
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            ConfluenceSoftwarePageVariantPaidLpConfSubAnchors,
                        entryName:
                            "confluence-software-page-variant-paid-lp-conf-subAnchors"
                    };
                }
            }
            if (
                !userLoggedIn &&
                route.variant &&
                isTargetedKeyword(route.keyword)
            ) {
                if (isEnrolledCpapiDeprecationConf) {
                    return {
                        Component:
                            ConfluenceSoftwarePageVariantPaidLpConfKeywordsRelay,
                        entryName:
                            "confluence-software-page-variant-paid-lp-conf-keywords-relay",
                        query: AnchorPageRelayQuery,
                        queryVars: getAnchorPageRelayQueryVars(
                            getPageIdKeywords(route.keyword),
                            location
                        ),
                        isRelayEnabled: true,
                        relayApi: RELAY_API_CONTENTFUL
                    };
                }
                return {
                    Component: ConfluenceSoftwarePageVariantPaidLpConfKeywords,
                    entryName:
                        "confluence-software-page-variant-paid-lp-conf-keywords"
                };
            }
            switch (route.variant) {
                case "paid-lp-conf-features":
                    // if treatment return the brand anchor page update, else control gets the old branding
                    if (
                        brandAnchorVisualCleanup.type == "enrolled" &&
                        brandAnchorVisualCleanup.value
                    ) {
                        return {
                            Component:
                                ConfluenceSoftwarePageVariantPaidLpConfFeaturesRelay,
                            entryName:
                                "confluence-software-page-variant-paid-lp-conf-features-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    } else {
                        return {
                            Component:
                                ConfluenceSoftwarePageVariantPaidLpConfFeatures,
                            entryName:
                                "confluence-software-page-variant-paid-lp-conf-features"
                        };
                    }
                case "paid-lp-confl-template":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageVariantPaidLpConflTemplateRelay,
                            entryName:
                                "confluence-software-page-variant-paid-lp-confl-template-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            ConfluenceSoftwarePageVariantPaidLpConflTemplate,
                        entryName:
                            "confluence-software-page-variant-paid-lp-confl-template"
                    };
                case "paid-lp-confl-documentation":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageVariantPaidLpConflDocumentationRelay,
                            entryName:
                                "confluence-software-page-variant-paid-lp-confl-documentation-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            ConfluenceSoftwarePageVariantPaidLpConflDocumentation,
                        entryName:
                            "confluence-software-page-variant-paid-lp-confl-documentation"
                    };
                case "paid-lp-confl-projectmgmt":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageVariantPaidLpConflProjectMgmtRelay,
                            entryName:
                                "confluence-software-page-variant-paid-lp-confl-projectmgmt-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            ConfluenceSoftwarePageVariantPaidLpConflProjectMgmt,
                        entryName:
                            "confluence-software-page-variant-paid-lp-confl-projectmgmt"
                    };
                case "paid-lp-xflow-redesign-experiment":
                    return {
                        Component:
                            ConfluenceSoftwarePageVariantPaidLpXflowRedesignExperiment,
                        entryName:
                            "confluence-software-page-variant-paid-lp-xflow-redesign-experiment"
                    };
                case "anchor-lp-conf-collaboration":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageVariantAnchorLpConfCollaborationRelay,
                            entryName:
                                "confluence-software-page-variant-anchor-lp-conf-collaboration-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component:
                            ConfluenceSoftwarePageVariantAnchorLpConfCollaboration,
                        entryName:
                            "confluence-software-page-variant-anchor-lp-conf-collaboration"
                    };
                case "anchor-lp-conf-automation":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageAnchorAutomationRelay,
                            entryName:
                                "confluence-software-anchor-lp-automation-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorAutomation,
                        entryName: "confluence-software-anchor-lp-automation"
                    };
                case "anchor-lp-conf-teamwork":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageAnchorTeamworkRelay,
                            entryName:
                                "confluence-software-anchor-lp-teamwork-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorTeamwork,
                        entryName: "confluence-software-anchor-lp-teamwork"
                    };
                case "anchor-lp-conf-competitors":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageAnchorCompetitorsRelay,
                            entryName:
                                "confluence-software-anchor-lp-competitors-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorCompetitors,
                        entryName: "confluence-software-anchor-lp-competitors"
                    };
                case "anchor-lp-conf-work-management":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageAnchorWorkManagementRelay,
                            entryName:
                                "confluence-software-anchor-lp-work-management-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorWorkManagement,
                        entryName:
                            "confluence-software-anchor-lp-work-management"
                    };
                case "anchor-lp-conf-team-engineering":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageAnchorEngineeringRelay,
                            entryName:
                                "confluence-software-anchor-lp-team-engineering-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorEngineering,
                        entryName:
                            "confluence-software-anchor-lp-team-engineering"
                    };
                case "anchor-lp-conf-team-marketing":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageAnchorMarketingRelay,
                            entryName:
                                "confluence-software-anchor-lp-team-marketing-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorMarketing,
                        entryName:
                            "confluence-software-anchor-lp-team-marketing"
                    };
                case "anchor-lp-conf-team-legal":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component: ConfluenceSoftwarePageAnchorLegalRelay,
                            entryName:
                                "confluence-software-anchor-lp-team-legal-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorLegal,
                        entryName: "confluence-software-anchor-lp-team-legal"
                    };
                case "anchor-lp-conf-team-hr":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component: ConfluenceSoftwarePageAnchorHrRelay,
                            entryName:
                                "confluence-software-anchor-lp-team-hr-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorHr,
                        entryName: "confluence-software-anchor-lp-team-hr"
                    };
                case "anchor-lp-conf-team-operations":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageAnchorOperationsRelay,
                            entryName:
                                "confluence-software-anchor-lp-team-operations-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorOperations,
                        entryName:
                            "confluence-software-anchor-lp-team-operations"
                    };
                case "anchor-lp-conf-team-design":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component: ConfluenceSoftwarePageAnchorDesignRelay,
                            entryName:
                                "confluence-software-anchor-lp-team-design-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorDesign,
                        entryName: "confluence-software-anchor-lp-team-design"
                    };
                case "anchor-lp-conf-team-programmgmt":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageAnchorProgramMgmtRelay,
                            entryName:
                                "confluence-software-anchor-lp-team-programmgmt-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorProgramMgmt,
                        entryName:
                            "confluence-software-anchor-lp-team-programmgmt"
                    };
                case "anchor-lp-conf-team-customerservice":
                    if (isEnrolledCpapiDeprecationConf) {
                        return {
                            Component:
                                ConfluenceSoftwarePageAnchorCustomerServiceRelay,
                            entryName:
                                "confluence-software-anchor-lp-team-customerservice-relay",
                            query: AnchorPageRelayQuery,
                            queryVars: getAnchorPageRelayQueryVars(
                                route.variant,
                                location
                            ),
                            isRelayEnabled: true,
                            relayApi: RELAY_API_CONTENTFUL
                        };
                    }
                    return {
                        Component: ConfluenceSoftwarePageAnchorCustomerService,
                        entryName:
                            "confluence-software-anchor-lp-team-customerservice"
                    };
                default:
                    return {
                        Component: ConfluenceSoftwarePage,
                        entryName: "confluence-software-page"
                    };
            }
        case "software/jira/service-management/pricing":
            if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                const jiraServiceManagementPricingTitle =
                    getJiraServiceManagementPricingTitleInternal();
                return {
                    Component: JiraServiceManagementPricingPageRelay,
                    entryName: "jira-service-management-pricing-page-relay",
                    query: PricingPageRelayQuery,
                    queryVars: getPricingPageRelayQueryVars(
                        "jira-service-management",
                        location,
                        jiraServiceManagementPricingTitle
                    ),
                    isRelayEnabled: true,
                    relayApi: RELAY_API_CONTENTFUL
                };
            }
            return {
                Component: JiraServiceManagementPricingPage,
                entryName: "jira-service-management-pricing-page"
            };

        case "software/confluence/pricing":
            if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                const confluencePricingTitleInternal =
                    getConfluencePricingTitleInternal();
                return {
                    Component: ConfluencePricingPageRelay,
                    entryName: "confluence-pricing-page-relay",
                    query: PricingPageRelayQuery,
                    queryVars: getPricingPageRelayQueryVars(
                        "confluence",
                        location,
                        confluencePricingTitleInternal
                    ),
                    isRelayEnabled: true,
                    relayApi: RELAY_API_CONTENTFUL
                };
            }
            return {
                Component: ConfluencePricingPage,
                entryName: "confluence-pricing-page"
            };

        case "software/confluence/free":
            return {
                Component: ConfluenceFreePage,
                entryName: "confluence-free-page"
            };

        case "software/confluence/templates": {
            const isRelay = getConfTemplatesRelayExperimentWithExposure(
                experiments.gwpAddRelayToConfluenceTemplatesLanding
            );
            if (isRelay) {
                return {
                    Component: ConfluenceTemplatesRelayPage,
                    entryName: "confluence-templates-relay-page",
                    query: ConfluenceTemplatesUnifiedRelayPageQuery,
                    queryVars:
                        getConfluenceTemplatesUnifiedRelayPageQueryVars(
                            location
                        ),
                    isRelayEnabled: true
                };
            } else {
                // The bifrost-template-parcel can change the below Component depending on the template data that is fetched
                return {
                    Component: ConfluenceTemplatesPage,
                    entryName: "confluence-templates-page"
                };
            }
        }

        case "try":
            return {
                Component: TryPage,
                entryName: "try-page"
            };

        case "try/cloud/signup":
            return {
                Component: SignupPage,
                entryName: "signup-page"
            };

        case "ondemand/signup/checkemail":
            return {
                Component: CheckemailPage,
                entryName: "checkemail-page"
            };

        case "ondemand/signup/confirmation":
        case "buy/cloud/confirmation":
            return {
                Component: ConfirmationPage,
                entryName: "confirmation-page",
                featureFlags: route.featureFlags
            };

        case "software/confluence/templates/search": {
            const isRelay = getConfTemplatesRelayExperimentWithExposure(
                experiments.gwpAddRelayToConfluenceTemplatesLanding
            );
            if (isRelay) {
                return {
                    Component: ConfluenceTemplateSearchRelayPage,
                    entryName: "confluence-template-search-relay-page",
                    query: ConfluenceTemplatesUnifiedRelayPageQuery,
                    queryVars:
                        getConfluenceTemplatesUnifiedRelayPageQueryVars(
                            location
                        ),
                    isRelayEnabled: true
                };
            } else {
                return {
                    Component: ConfluenceTemplateSearchPage,
                    entryName: "confluence-template-search-page"
                };
            }
        }

        case `software/confluence/templates/categories${getRouteExtension(
            route.path,
            "software/confluence/templates/categories"
        )}`: {
            const isRelay = getConfTemplatesRelayExperimentWithExposure(
                experiments.gwpAddRelayToConfluenceTemplateCategories
            );
            if (isRelay) {
                return {
                    Component: ConfluenceTemplateCategoryRelayPage,
                    entryName: "confluence-template-category-relay-page",
                    query: ConfluenceTemplatesUnifiedRelayPageQuery,
                    queryVars:
                        getConfluenceTemplatesUnifiedRelayPageQueryVars(
                            location
                        ),
                    isRelayEnabled: true
                };
            } else {
                return {
                    Component: ConfluenceTemplateCategoryPage,
                    entryName: "confluence-template-category-page"
                };
            }
        }

        case `software/confluence/templates/collections${getRouteExtension(
            route.path,
            "software/confluence/templates/collections"
        )}`: {
            const isRelay = checkFeatureFlagGate(
                featureFlags.gwpRelayConfTemplateCollectionDetails
            );
            const isContentfulRelay = checkFeatureFlagGate(
                featureFlags.cpapiwdConfluenceTemplateCollectionDetails
            );
            if (isContentfulRelay) {
                return {
                    Component:
                        ConfluenceTemplateCollectionDetailsContentfulRelayPage,
                    entryName:
                        "confluence-template-collection-details-contentful-relay-page",
                    query: ConfluenceTemplateCollectionDetailsContentfulRelayPageQuery,
                    queryVars:
                        getConfluenceTemplateCollectionDetailsContentfulRelayPageQueryVars(
                            location
                        ),
                    isRelayEnabled: true,
                    relayApi: RELAY_API_CONTENTFUL
                };
            } else if (isRelay) {
                return {
                    Component: ConfluenceTemplateCollectionDetailsRelayPage,
                    entryName:
                        "confluence-template-collection-details-relay-page",
                    query: ConfluenceTemplateCollectionDetailsRelayPageQuery,
                    queryVars:
                        getConfluenceTemplateCollectionDetailsRelayPageQueryVars(
                            location
                        ),
                    isRelayEnabled: true
                };
            } else {
                return {
                    Component: ConfluenceTemplateCollectionDetailsPage,
                    entryName: "confluence-template-collection-details-page"
                };
            }
        }

        case `software/jira/templates/service-management`:
            return {
                Component: JiraTemplateCategoryPage,
                entryName: "jira-template-category-page"
            };

        case `software/jira/templates${getRouteExtension(
            route.path,
            "software/jira/templates"
        )}`:
            return {
                Component: TestUniformPage,
                entryName: "test-uniform-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };

        case "enterprise/contact":
            return {
                Component: EnterpriseContactSalesPage,
                entryName: "enterprise-contact-sales-page"
            };

        case "enterprise/contact-thanks":
            switch (route.variant) {
                case "product-features":
                    return {
                        Component: EnterpriseContactThanksPage,
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "pricing-quotes":
                    return {
                        Component: EnterpriseContactThanksPage,
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "migration-options":
                    return {
                        Component: EnterpriseContactThanksPage,
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "billing-licensing":
                    return {
                        Component: EnterpriseContactThanksPage,
                        entryName: "enterprise-contact-thanks-page"
                    };
                case "technical-support":
                    return {
                        Component: EnterpriseContactThanksPage,
                        entryName: "enterprise-contact-thanks-page"
                    };
                default:
                    return {
                        Component: EnterpriseContactThanksPage,
                        entryName: "enterprise-contact-thanks-page"
                    };
            }

        case "enterprise/success":
            return {
                Component: TestUniformPage,
                entryName: "test-uniform-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };

        case "software/confluence/enterprise":
            return {
                Component: TestUniformPage,
                entryName: "test-uniform-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };

        case "software/jira/enterprise":
            return {
                Component: TestUniformPage,
                entryName: "test-uniform-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };

        case "software/jira/service-management/enterprise":
            return {
                Component: TestUniformPage,
                entryName: "test-uniform-page",
                isUniformCanary: route.isUniformCanary,
                isS3UniformRoute: true
            };

        case "enterprise":
            if (checkFeatureFlagGate(featureFlags.enterprisePageDXPMigration)) {
                return {
                    Component: TestUniformPage,
                    entryName: "test-uniform-page",
                    isUniformCanary: route.isUniformCanary,
                    isS3UniformRoute: true
                };
            }
            return {
                Component: EnterpriseLandingPage,
                entryName: "enterprise-landing-page"
            };

        case "teams/nonprofits/discount-pricing":
            if (checkFeatureFlagGate(featureFlags.cpapiwdPricingAll)) {
                return {
                    Component: NonProfitPricingPageRelay,
                    entryName: "non-profit-pricing-page-relay",
                    query: PricingPageRelayQuery,
                    queryVars: getPricingPageRelayQueryVars(
                        "nonprofit",
                        location
                    ),
                    isRelayEnabled: true,
                    relayApi: RELAY_API_CONTENTFUL
                };
            }
            return {
                Component: NonProfitPricingPage,
                entryName: "non-profit-pricing-page"
            };

        case `software/confluence/templates${getRouteExtension(
            route.path,
            "software/confluence/templates"
        )}`: {
            const isRelay = checkFeatureFlagGate(
                featureFlags.gwpRelayConfTemplateDetails
            );
            const isContentfulRelay = checkFeatureFlagGate(
                featureFlags.cpapiwdConfluenceTemplateDetails
            );
            if (isContentfulRelay) {
                return {
                    Component: ConfluenceTemplateDetailsContentfulRelayPage,
                    entryName:
                        "confluence-template-details-contentful-relay-page",
                    query: ConfluenceTemplateDetailsContentfulRelayPageQuery,
                    queryVars:
                        getConfluenceTemplateDetailsContentfulRelayPageQueryVars(
                            location
                        ),
                    isRelayEnabled: true,
                    relayApi: RELAY_API_CONTENTFUL
                };
            } else if (isRelay) {
                return {
                    Component: ConfluenceTemplateDetailsRelayPage,
                    entryName: "confluence-template-details-relay-page",
                    query: ConfluenceTemplateDetailsRelayPageQuery,
                    queryVars:
                        getConfluenceTemplateDetailsRelayPageQueryVars(
                            location
                        ),
                    isRelayEnabled: true
                };
            } else {
                return {
                    Component: ConfluenceTemplateDetailsPage,
                    entryName: "confluence-template-details-page"
                };
            }
        }

        case "cdn-library":
            return {
                Component: CDNLibrary,
                entryName: "cdn-library"
            };
        case "search":
            return {
                Component: SearchResultsPage,
                entryName: "search"
            };

        case "":
            return { Component: HomePage, entryName: "home" };

        default: {
            return { Component: FourOhFourPage, entryName: "404" };
        }
    }
};

const getRouteExtension = (path: string, baseTemplate: string) => {
    const pathExtn = path.split(baseTemplate)[1];
    return pathExtn ? pathExtn : "";
};
